<template>
    <img src="/images/promo/hero-section/star-struck.png"
     alt="Star struck" />
</template>

<script>
export default {};
</script>
